import { useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { getUnits } from 'src/Query';
import { useUser } from 'src/utils/authentication';

const unitMap = {
  inverse_concentration: 'dl/g',
  pressure: 'MPa',
  unitless: '',
  length_per_time: 'g/10min',
  temperature: '°C',
  hardness_scale: 'Rockwell E',
  hardness: 'Mohr',
  length: 'm',
  time: 's',
  weight: 'kg',
  percent: '%',
  electric_potential_per_length: 'kV/cm',
  density: 'g/ml',
  energy: 'kJ',
  energy_per_area: 'ft-lb/in^2',
  concentration: 'ppm',
  inverse_temperature: '/°C',
  flow: 'g/10min',
  electrical_potential_per_length: 'kV/mm',
  electrical_potential: 'V',
  electrical_resistance_length: 'Ω cm'
};

export function defaultUnitForType(type) {
  return unitMap[type] || '';
}

export function useAvailableUnits() {
  const { data } = useQuery(['units'], () => getUnits());

  if (!data) return null;

  return data;
}

export function useAvailableUnitsForType(type) {
  const { data } = useQuery(['units'], () => getUnits());

  if (!data) return [];

  if (!type || !data[type]) {
    return [];
  }

  return data[type];
}

export function usePreferredUnits(type) {
  const { data: user } = useUser();

  return type ? user?.preferences?.units[type] : user?.preferences;
}

export function PreferredUnits({ type }) {
  const units = usePreferredUnits(type);

  return units;
}
PreferredUnits.propTypes = {
  type: PropTypes.string
};
